import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

class FormArrayMinError extends React.Component {
    render() {
        return (
            <FormattedMessage id={this.props.field_name}>
                {
                    (field) =>
                        <FormattedMessage id={"CMS.Form.array.min"}
                            values={{ field: field, min: this.props.min }}>
                            {
                                (message) => <p>{message}</p>
                            }
                        </FormattedMessage>
                }
            </FormattedMessage>
        );
    }
}

FormArrayMinError.propTypes = {
    field_name: PropTypes.string.isRequired,
    min: PropTypes.number.isRequired
};
export default FormArrayMinError